module.exports = __webpack_public_path__ + "img/horizontal_4_5_4.b609e7e6.png";